var map = {
	"./docente.json": "6a6d",
	"./docente_occhiali.json": "bf4a",
	"./docente_stroke.json": "8393",
	"./famiglie.json": "b4e6",
	"./famiglie_stroke.json": "b85d",
	"./loader.json": "b434",
	"./loader_zm.json": "c42a",
	"./loader_zs.json": "a4aa",
	"./pinjump.json": "a2db",
	"./studenti.json": "a2e8",
	"./studenti_stroke.json": "4cb4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f80";